/*
 *
 * PaymentMethods actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  GET_PAYMENT_METHODS,
  GET_OTHER_AVAILABLE_MODES,
  HANDLE_PAYMENT_METHODS_RESPONSE,
  HANDLE_OTHER_AVAILABLE_MODES_RESPONSE,
  GET_PAYPAL_CONFIG,
  HANDLE_PAYPAL_CONFIG_RESPONSE,
  RESET_PAYMENT_METHOD_CARD_LOADER,
  INITIATE_PAYPAL,
  ACTIVATE_PAYPAL_CURRENCY,
  DEACTIVATE_PAYPAL_CURRENCY,
  UPDATE_DEFAULT_PAYPAL_CURRENCY,
  HANDLE_UPDATE_DEFAULT_PAYPAL_CURRENCY,
  HANDLE_DEACTIVATE_PAYPAL_CURRENCY,
  HANDLE_ACTIVATE_PAYPAL_CURRENCY,
  SAVE_PAYPAL_DATA,
  RESET_PAYPAL_CONFIG,
  RESET_DATA,
  ENABLE_PAYMENT_METHOD,
  GET_PAYTM_DATA,
  SAVE_PAYTM_DATA,
  GET_PAYTM_TEST_CONFIG,
  SAVE_PAYTM_PROD_CONFIG,
  SAVE_PAYTM_TEST_CONFIG,
  ADD_PAYTM_PROD_CONFIG,
  ADD_PAYTM_TEST_CONFIG,
  GET_PAYTM_CHECKSUMHASH,
  RESET_PAYTM_WALLET,
  GET_DOCS_PER_PAYMENT_METHOD,
  SAVE_UPLOAD_DOCUMENTS_FORM,
  DOWNLOAD_DOCUMENT,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getPaymentMethodsAction(data) {
  return {
    type: GET_PAYMENT_METHODS,
    data,
  };
}

export function handlePaymentMethodsResponse(data) {
  return {
    type: HANDLE_PAYMENT_METHODS_RESPONSE,
    data,
  };
}

export function getOtherAvailableModesAction(data) {
  return {
    type: GET_OTHER_AVAILABLE_MODES,
    data,
  };
}

export function handleOtherAvailableModesResponse(data) {
  return {
    type: HANDLE_OTHER_AVAILABLE_MODES_RESPONSE,
    data,
  };
}

export function getPaypalConfigAction(data) {
  return {
    type: GET_PAYPAL_CONFIG,
    data,
  };
}

export function handlePaypalConfigResponse(data) {
  return {
    type: HANDLE_PAYPAL_CONFIG_RESPONSE,
    data,
  };
}

export function resetPaymentMethodCardLoaderAction(data) {
  return {
    type: RESET_PAYMENT_METHOD_CARD_LOADER,
    data,
  };
}

export function initiatePaypalAction(data) {
  return {
    type: INITIATE_PAYPAL,
    data,
  };
}

export function activatePaypalCurrencyAction(data) {
  return {
    type: ACTIVATE_PAYPAL_CURRENCY,
    data,
  };
}

export function deactivatePaypalCurrencyAction(data) {
  return {
    type: DEACTIVATE_PAYPAL_CURRENCY,
    data,
  };
}

export function updateDefaultPaypalCurrencyAction(data) {
  return {
    type: UPDATE_DEFAULT_PAYPAL_CURRENCY,
    data,
  };
}

export function handleUpdateDefaultPaypalCurrency(data) {
  return {
    type: HANDLE_UPDATE_DEFAULT_PAYPAL_CURRENCY,
    data,
  };
}

export function handleDeactivatePaypalCurrency(data) {
  return {
    type: HANDLE_DEACTIVATE_PAYPAL_CURRENCY,
    data,
  };
}

export function handleActivatePaypalCurrency(data) {
  return {
    type: HANDLE_ACTIVATE_PAYPAL_CURRENCY,
    data,
  };
}

export function savePaypalDataAction(data) {
  return {
    type: SAVE_PAYPAL_DATA,
    data,
  };
}

export function resetPaypalConfigAction(data) {
  return {
    type: RESET_PAYPAL_CONFIG,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function enablePaymentMethodAction(data) {
  return {
    type: ENABLE_PAYMENT_METHOD,
    data,
  };
}

export function getPaytmDataAction() {
  return {
    type: GET_PAYTM_DATA,
  };
}

export function savePaytmDataAction(data) {
  return {
    type: SAVE_PAYTM_DATA,
    data,
  };
}

export function getPaytmTestConfigAction() {
  return {
    type: GET_PAYTM_TEST_CONFIG,
  };
}

export function savePaytmProdConfigAction(data) {
  return {
    type: SAVE_PAYTM_PROD_CONFIG,
    data,
  };
}

export function savePaytmTestConfigAction(data) {
  return {
    type: SAVE_PAYTM_TEST_CONFIG,
    data,
  };
}

export function addPaytmProdConfigAction(data) {
  return {
    type: ADD_PAYTM_PROD_CONFIG,
    data,
  };
}

export function addPaytmTestConfigAction(data) {
  return {
    type: ADD_PAYTM_TEST_CONFIG,
    data,
  };
}

export function getPaytmCheckSumHashAction(data) {
  return {
    type: GET_PAYTM_CHECKSUMHASH,
    data,
  };
}

export function resetPaytmWalletAction(data) {
  return {
    type: RESET_PAYTM_WALLET,
    data,
  };
}

export function getDocsPerPaymentMethodAction(data) {
  return {
    type: GET_DOCS_PER_PAYMENT_METHOD,
    data,
  };
}

export function saveUploadDocumentsFormAction(data) {
  return {
    type: SAVE_UPLOAD_DOCUMENTS_FORM,
    data,
  };
}

export function downloadDocumentAction(data) {
  return {
    type: DOWNLOAD_DOCUMENT,
    data,
  };
}
